import { render } from "./newsinfo-count.vue?vue&type=template&id=4be33010&scoped=true"
import script from "./newsinfo-count.vue?vue&type=script&lang=js"
export * from "./newsinfo-count.vue?vue&type=script&lang=js"

import "./newsinfo-count.vue?vue&type=style&index=0&id=4be33010&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be33010"]])

export default __exports__